import {
  Button,
  CircularProgress,
  Divider,
  DrawerBody, DrawerHeader, Stack,
} from '@datanomik/commons-ui';
import {
  AddOutlined, BugReport, CodeOutlined,
  LightbulbOutlined,
  Telegram,
} from '@mui/icons-material';
import { ExternalLinkLine } from '@datanomik/commons-ui/icons';
import { useTranslation } from 'react-i18next';
import { useClientProfile } from '@/hooks/useClientProfile';
import { ActionRow } from '../../shared/action-row/ActionRow';
import { SupportPanelAvailabilityArea } from './support-panel-home-areas/availability/SupportPanelAvailabilityArea';
import { AccountManagerRow } from './support-panel-home-areas/account-manager/AccountManagerRow';
import { SupportIcon } from '../../shared/icons/SupportIcon';
import { AreaHeader } from '../../shared/area-header/AreaHeader';

type SupportPanelHomeProps = {
  onReportProblem?: () => void
  onSuggestions?: () => void;
};

export const SupportPanelHome = ({ onReportProblem, onSuggestions }: SupportPanelHomeProps) => {
  const { t } = useTranslation();
  const {
    clientProfile, isLoading,
  } = useClientProfile();

  return (
    <>

      <DrawerHeader
        startAdornment={<SupportIcon />}
        text={t('Support')}
      />

      <DrawerBody>
        <Stack>
          <SupportPanelAvailabilityArea />
          {isLoading && (
            <Stack sx={{
              padding: '24px',
              justifyContent: 'center',
              alignItems: 'center',
              minHeight: '140px',
            }}
            >
              <CircularProgress color="primary" size="20px" />
            </Stack>
          )}
          {!isLoading && <AccountManagerRow manager={clientProfile.accountManager} />}
          <AreaHeader title={t('General Support')} />
          <Stack>
            <ActionRow
              color="red"
              icon={<BugReport />}
              title={t('Report a problem')}
              subtitle={t('Open a ticket for the technical team')}
              actions={[
                <Button
                  variant="outlined"
                  color="black"
                  size="small"
                  startIcon={<AddOutlined />}
                  onClick={onReportProblem}
                >
                  {t('Report.action')}
                </Button>,
              ]}
            />
            <Divider />
            <ActionRow
              color="green"
              icon={<CodeOutlined />}
              title={t('Documentation')}
              subtitle={t('Check out how to integrate our APIs')}
              actions={[
                <Button
                  onClick={() => {
                    window.open('https://docs.datanomik.com/docs/getting-started', '_blank');
                  }}
                  variant="outlined"
                  color="black"
                  size="small"
                  startIcon={<ExternalLinkLine />}
                >
                  {t('Open')}
                </Button>,
              ]}
            />
          </Stack>
          <AreaHeader title="Queremos ouvir você" />
          <ActionRow
            color="teal"
            icon={<LightbulbOutlined />}
            title={t('Suggestions & Improvements')}
            subtitle={t('Send us your idea')}
            actions={[
              <Button
                variant="outlined"
                color="black"
                size="small"
                startIcon={<Telegram fontSize="small" />}
                onClick={onSuggestions}
              >
                {t('Suggest')}
              </Button>,
            ]}
          />
        </Stack>
      </DrawerBody>
    </>
  );
};
